import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { PPL_DIALOG_DATA, PplDialogRef } from '@ppl/ui/dialog';


@Component({
  selector: 'ppl-space-access-blocked-dialog',
  standalone: false,
  templateUrl: './space-access-blocked-dialog.component.html',
  styleUrl: './space-access-blocked-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpaceAccessBlockedDialogComponent {

  get message() {
    return this.data.message;
  }

  constructor(
    private dialogRef: PplDialogRef<SpaceAccessBlockedDialogComponent>,
    @Inject(PPL_DIALOG_DATA) private data: SpaceAccessBlockedData
  ) { }
}

export interface SpaceAccessBlockedData {
  message: string;
}
